<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <material-card
          color="primary"
          icon="mdi-account-outline"
        >
          <template #title>
            用户配置
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="user"
                    label="用户名"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    name="input-10-1"
                    label="密码"
                    color="purple"
                    hint="至8个字符"
                    counter
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                  />
                </v-col>

                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="shared"
                    readonly
                    label="共享连接"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    min-width="150"
                    @click="login"
                  >
                    登陆
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>

      <v-col
        cols="12"
        md="8"
      >
        <material-card
          color="primary"
        >
          <template #title>
            修改密码
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="oldPassword"
                    name="input-10-1"
                    label="旧密码"
                    color="purple"
                    counter
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPassword"
                    name="input-10-1"
                    label="新密码"
                    color="purple"
                    hint="至8个字符"
                    counter
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show3 ? 'text' : 'password'"
                    @click:append="show3 = !show3"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    min-width="150"
                    @click="changePassword"
                  >
                    保存
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      timeout=2000
      top
      right
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'UserProfileView',
    data () {
      return {
        show: false,
        show2: false,
        show3: false,
        user: '',
        password: '',
        newPassword: '',
        oldPassword: '',
        shared: '',
        snackbar: false,
        snackbarText: '',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || '最少8个字符',
        },
      }
    },

    computed: {
      User () {
        return this.$store.getters.done_user_name
      },
      Password () {
        return this.$store.getters.done_user_password
      },
    },

    mounted () {
      this.user = this.User
      this.password = '*****************'
      this.getShared()
    },

    methods: {
      login () {
        const _this = this
        this.$axios.post('/', {
          data: {
            operation: 'userLogin',
            user: this.user,
            password: this.password,
          },
        }).then((response) => {
          if (response.data.login === true) {
            _this.$store.dispatch('user_login', {
              name: _this.user,
              password: _this.password,
            })
            _this.snackbar = true
            _this.snackbarText = '登陆成功'
            _this.getShared()
          } else {
            _this.snackbar = true
            _this.snackbarText = '用户名或密码错误'
          }
        })
      },
      changePassword () {
        const _this = this
        this.$axios.post('/', {
          data: {
            operation: 'ChangePassword',
            user: this.User,
            password: this.oldPassword,
            newpassword: this.newPassword,
          },
        }).then((response) => {
          if (response.data.updata === true) {
            _this.$store.dispatch('user_login', {
              name: _this.User,
              password: _this.newPassword,
            })
            _this.oldPassword = ''
            _this.newPassword = ''
            _this.snackbar = true
            _this.snackbarText = '修改完成'
          } else {
            _this.snackbar = true
            _this.snackbarText = '密码错误'
          }
        })
      },
      getShared () {
        const _this = this
        this.$axios.post('/', {
          data: {
            operation: 'getShared',
            user: this.User,
            password: this.Password,
          },
        }).then((response) => {
          _this.shared = response.data.shared !== '' ? 'https://luascript.alcedo.top/link/?link=' + response.data.shared : ''
        })
      },
    },
  }
</script>
